/*
 * Design Studio wizard controller (Custom Jewelry page).
 * Progressive enhancement over a native {% form 'contact' %}: shows one step at a
 * time, inserts the conditional Ring-size step, tracks progress, validates, and
 * renders the confirmation view. Config comes from data- attributes on the outer
 * .cj-wiz container (NOT the Shopify form tag, which does not reliably emit custom
 * attributes), so this file needs no Liquid and lives in assets/.
 */
(function () {
  function initWizard(container) {
    if (container.__cjInit) return;
    var form = container.querySelector('form.cj-wiz__form') || container.querySelector('form');
    if (!form) return;
    container.__cjInit = true;

    var doneDefault = container.getAttribute('data-cj-done-body') || '';
    var submitLabel = container.getAttribute('data-cj-submit-label') || 'Submit Request';

    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-cj-step]'));
    var progress = form.querySelector('[data-cj-progress]');
    var stepLabel = form.querySelector('[data-cj-steplabel]');
    var stepTitle = form.querySelector('[data-cj-steptitle]');
    var backBtn = form.querySelector('[data-cj-back]');
    var nextBtn = form.querySelector('[data-cj-next]');
    var nextLabel = form.querySelector('[data-cj-nextlabel]');
    var summaryEl = form.querySelector('[data-cj-summary]');
    var doneBody = form.querySelector('[data-cj-donebody]');
    var typeInputs = Array.prototype.slice.call(form.querySelectorAll('[data-cj-typeinput]'));
    var conditionalStep = form.querySelector('[data-cj-step="size"]');
    var conditionalValue = conditionalStep ? conditionalStep.getAttribute('data-cj-conditional') : null;
    var nameInput = form.querySelector('[data-cj-name]');
    var emailInput = form.querySelector('[data-cj-email]');

    if (!steps.length || !nextBtn) return; // nothing to drive

    container.classList.add('cj-wiz--js');
    // The wizard does its own validation. Turn off native HTML validation, which
    // would otherwise block subm/advance because required fields (name, email,
    // piece type) sit in hidden steps and cannot be focused to report validity.
    form.noValidate = true;
    var idx = 0;

    function selectedType() {
      for (var i = 0; i < typeInputs.length; i++) { if (typeInputs[i].checked) return typeInputs[i].value; }
      return '';
    }
    // Active step list: drop the conditional ring-size step unless its type is chosen.
    function activeSteps() {
      return steps.filter(function (el) {
        var cond = el.getAttribute('data-cj-conditional');
        if (!cond) return true;
        return selectedType() === cond;
      });
    }
    function emailValid(v) { return /.+@.+\..+/.test(v || ''); }
    function canAdvance(stepEl) {
      var id = stepEl.getAttribute('data-cj-step');
      if (id === 'type') return !!selectedType();
      if (id === 'contact') return !!(nameInput && nameInput.value.trim()) && emailValid(emailInput && emailInput.value);
      return true;
    }

    function render() {
      var list = activeSteps();
      if (idx >= list.length) idx = list.length - 1;
      if (idx < 0) idx = 0;
      var cur = list[idx];

      steps.forEach(function (el) { el.classList.toggle('is-active', el === cur); });

      var total = list.length;
      if (stepLabel) stepLabel.textContent = 'Step ' + (idx + 1) + ' of ' + total;
      if (stepTitle) stepTitle.textContent = cur.getAttribute('data-cj-title') || '';
      if (progress) progress.style.width = Math.round(((idx + 1) / total) * 100) + '%';

      if (backBtn) backBtn.style.visibility = idx > 0 ? 'visible' : 'hidden';

      var isReview = cur.getAttribute('data-cj-step') === 'review';
      if (nextLabel) nextLabel.textContent = isReview ? submitLabel : 'Continue';
      var ok = canAdvance(cur);
      nextBtn.classList.toggle('is-disabled', !ok);
      nextBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');

      if (isReview) buildSummary();
    }

    function fieldValue(name) {
      var checked = form.querySelector('[name="contact[' + name + ']"]:checked');
      if (checked) return checked.value.trim();
      var el = form.querySelector('[name="contact[' + name + ']"]');
      return el ? el.value.trim() : '';
    }

    function buildSummary() {
      if (!summaryEl) return;
      var rows = [];
      function add(k, v) { if (v) rows.push([k, v]); }
      add('Piece', selectedType() || 'Not specified');
      if (selectedType() === conditionalValue) add('Ring size', fieldValue('Ring size') || 'Not specified');
      add('Inspiration', fieldValue('Inspiration') || 'None shared');
      add('Your idea', fieldValue('body') || 'To discuss');
      add('Budget', fieldValue('Budget') || 'Not specified');
      add('Timeline', fieldValue('Timeline') || 'Not specified');
      var contact = [fieldValue('Name'), fieldValue('email'), fieldValue('Phone')].filter(Boolean).join(', ');
      add('Contact', contact || 'Not specified');

      summaryEl.innerHTML = '';
      rows.forEach(function (r) {
        var d = document.createElement('div'); d.className = 'cj-wiz__sumrow';
        var k = document.createElement('span'); k.className = 'cj-wiz__sumk'; k.textContent = r[0];
        var v = document.createElement('span'); v.className = 'cj-wiz__sumv'; v.textContent = r[1];
        d.appendChild(k); d.appendChild(v); summaryEl.appendChild(d);
      });
    }

    function goNext() {
      var list = activeSteps();
      var cur = list[idx];
      if (!canAdvance(cur)) return;
      if (cur.getAttribute('data-cj-step') === 'review') { submit(); return; }
      idx = Math.min(idx + 1, activeSteps().length - 1);
      render();
    }
    function goBack() { idx = Math.max(idx - 1, 0); render(); }

    function showDone() {
      var name = nameInput && nameInput.value.trim();
      if (doneBody) doneBody.textContent = name ? ('Thank you, ' + name + '. ' + doneDefault) : doneDefault;
      container.classList.add('cj-wiz--done');
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function submit() {
      // Enhanced submit: POST the whole form so Shopify emails it, then show the
      // confirmation inline (no reload). Falls back to a native submit on failure.
      if (nameInput && !nameInput.value.trim()) return;
      if (emailInput && !emailValid(emailInput.value)) return;
      var data = new FormData(form);
      fetch(form.action, { method: 'POST', body: data, headers: { 'Accept': 'text/html' } })
        .then(function (res) { if (res && (res.ok || res.type === 'opaqueredirect' || res.status === 0)) { showDone(); } else { form.submit(); } })
        .catch(function () { form.submit(); });
    }

    // Continue is a plain button (type="button"), driven by click. The form's
    // submit event is also caught so the Enter key advances instead of posting.
    nextBtn.addEventListener('click', function (e) { e.preventDefault(); goNext(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); goNext(); });
    if (backBtn) backBtn.addEventListener('click', goBack);
    typeInputs.forEach(function (el) { el.addEventListener('change', render); });
    if (nameInput) nameInput.addEventListener('input', render);
    if (emailInput) emailInput.addEventListener('input', render);

    Array.prototype.forEach.call(form.querySelectorAll('[data-cj-advance]'), function (b) {
      b.addEventListener('click', goNext);
    });
    Array.prototype.forEach.call(form.querySelectorAll('[data-cj-set-advance]'), function (b) {
      b.addEventListener('click', function () {
        var name = b.getAttribute('data-cj-set-advance');
        var value = b.getAttribute('data-cj-value');
        var field = form.querySelector('[name="contact[' + name + ']"][value="' + value.replace(/"/g, '\\"') + '"]');
        if (field) field.checked = true;
        goNext();
      });
    });

    var resetBtn = form.querySelector('[data-cj-reset]');
    if (resetBtn) resetBtn.addEventListener('click', function () {
      form.reset();
      container.classList.remove('cj-wiz--done');
      idx = 0;
      render();
    });

    render();

    // If Shopify re-rendered the page after a native (no-JS) post, show the
    // confirmation over the wizard. All handlers (including reset) are already
    // bound above, so "Start Another" works from this path too.
    if (container.querySelector('[data-cj-posted]')) {
      container.classList.add('cj-wiz--done');
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('.cj-wiz[data-cj-wizard]'), initWizard);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Re-init in the Shopify theme editor when the section reloads.
  document.addEventListener('shopify:section:load', function (e) { init(e && e.target ? e.target : document); });
})();
